"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const common_utils_1 = require("@riseupil/common-utils");
const cashflow_1 = require("../components/cashflow");
const actions = __importStar(require("./actions"));
const consts_1 = require("../consts");
const utils_1 = require("./utils");
function _initOptimistic(cashflow, dateLocale = common_utils_1.DateLocales.EN_IL) {
    return new cashflow_1.ReactiveCashflow(lodash_1.default.cloneDeep(cashflow), dateLocale);
}
function _returnUpdated(cashflow) {
    return cashflow.toJson();
}
function validateInputNotUndefined(input) {
    if (lodash_1.default.isUndefined(input)) {
        throw new Error('Got undefined input in Optimus');
    }
}
function cancelEnvelope(cashflow, { envelopeId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(envelopeId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.cancelEnvelope(oc, envelopeId);
    return _returnUpdated(oc);
}
function updateEnvelopeAmount(cashflow, { envelopeId, amount }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(envelopeId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.updateEnvelopeAmount(oc, envelopeId, amount, true);
    return _returnUpdated(oc);
}
function updateEnvelopeBalanceDate(cashflow, { cashflowMonth, sequenceId, isPermanent }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(cashflowMonth);
    validateInputNotUndefined(sequenceId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.updateEnvelopeBalanceDate(oc, cashflowMonth, sequenceId);
    return _returnUpdated(oc);
}
function updateRiseupGoal(cashflow, { amount }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.updateRiseupGoalAmount(oc, amount);
    return _returnUpdated(oc);
}
function moveVariableExpenseToFixed(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.moveVariableExpenseToFixed(oc, transactionId);
    return _returnUpdated(oc);
}
function moveExpenseToFixed(cashflow, { transactionId, expense }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.moveExpenseToFixed(oc, transactionId, expense);
    return _returnUpdated(oc);
}
function moveFixedToVariable(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.moveFixedToVariable(oc, transactionId);
    return _returnUpdated(oc);
}
function excludeExpense(cashflow, { transactionId, popExpense }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.excludeExpense(oc, transactionId, popExpense);
    return _returnUpdated(oc);
}
function moveVariableIncomeToFixed(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.moveVariableIncomeToFixed(oc, transactionId);
    return _returnUpdated(oc);
}
function moveIncomeToFixed(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    const transaction = actions.popTransaction(oc, transactionId, utils_1.findSourceTransactionsByTransactionId(oc, transactionId));
    actions.markAsNotExcluded(transaction);
    actions.putOnFixed(oc, transaction);
    return _returnUpdated(oc);
}
function moveExcludedToVariableExpense(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.moveExcludedToVariableExpense(oc, transactionId);
    return _returnUpdated(oc);
}
function moveExcludedToVariableIncome(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.moveExcludedToVariableIncome(oc, transactionId);
    return _returnUpdated(oc);
}
function unexcludeTransaction(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    return moveExcludedToVariableIncome(cashflow, { transactionId }, dateLocale);
}
function excludeVariableExpense(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.excludeVariableExpense(oc, transactionId);
    return _returnUpdated(oc);
}
function excludeVariableIncome(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.excludeVariableIncome(oc, transactionId);
    return _returnUpdated(oc);
}
function excludeIncome(cashflow, { transactionId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.excludeIncome(oc, transactionId);
    return _returnUpdated(oc);
}
function changeCategory(cashflow, { businessName, expense, transactionId, applyTo, popEnvelope = false }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    if (applyTo === consts_1.ENRICHMENT_INPUT_TYPES.TRANSACTION_ID) {
        validateInputNotUndefined(transactionId);
    }
    else {
        validateInputNotUndefined(businessName);
    }
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.changeCategory(oc, businessName, expense, transactionId, applyTo, popEnvelope);
    return _returnUpdated(oc);
}
function changeTransactionCategory(cashflow, { trackingCategoryId, matchBy, value, popEnvelope }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.changeTransactionCategory(oc, trackingCategoryId, matchBy, value, popEnvelope);
    return _returnUpdated(oc);
}
function moveFromTracking(cashflow, { matchBy, value }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.moveFromTracking(oc, matchBy, value);
    return _returnUpdated(oc);
}
function disableTrackingCategory(cashflow, { envelopeId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.cancelEnvelope(oc, envelopeId);
    return _returnUpdated(oc);
}
function deactivateTrackingCategory(cashflow, { envelopeId }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    return disableTrackingCategory(cashflow, { envelopeId }, dateLocale);
}
function changeEnvelopeExpenseCategory(cashflow, { envelopeId, expenseCategory }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(envelopeId);
    validateInputNotUndefined(expenseCategory);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.changeEnvelopeExpenseCategory(oc, envelopeId, expenseCategory);
    return _returnUpdated(oc);
}
function setIncomePredictionAmount(cashflow, { amount }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(amount);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.setIncomePredictionAmount(oc, amount);
    return _returnUpdated(oc);
}
function setTransactionComment(cashflow, { transactionId, comment }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.setTransactionComment(oc, transactionId, comment);
    return _returnUpdated(oc);
}
function setSequenceComment(cashflow, { sequenceId, comment }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(sequenceId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.setSequenceComment(oc, sequenceId, comment);
    return _returnUpdated(oc);
}
function splitTransaction(cashflow, { transactionId, slices, actionType }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(transactionId);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.splitTransaction(oc, transactionId, slices, actionType);
    return _returnUpdated(oc);
}
function showTrackingCategory(cashflow, { amount, name, trackingCategoryId, icon, frequency, isCustomPrediction, defaultAmount }, dateLocale = common_utils_1.DateLocales.EN_IL) {
    validateInputNotUndefined(amount);
    validateInputNotUndefined(name);
    validateInputNotUndefined(trackingCategoryId);
    validateInputNotUndefined(icon);
    const oc = _initOptimistic(cashflow, dateLocale);
    actions.showTrackingCategory(oc, name, amount, trackingCategoryId, icon, frequency, isCustomPrediction, defaultAmount, dateLocale);
    return _returnUpdated(oc);
}
exports.default = {
    cancelEnvelope,
    updateEnvelopeAmount,
    updateEnvelopeBalanceDate,
    updateRiseupGoal,
    moveVariableExpenseToFixed,
    moveVariableIncomeToFixed,
    moveIncomeToFixed,
    moveExcludedToVariableExpense,
    moveExcludedToVariableIncome,
    unexcludeTransaction,
    excludeVariableExpense,
    excludeVariableIncome,
    setIncomePredictionAmount,
    changeCategory,
    changeTransactionCategory,
    moveFromTracking,
    disableTrackingCategory,
    changeEnvelopeExpenseCategory,
    moveFixedToVariable,
    showTrackingCategory,
    setTransactionComment,
    setSequenceComment,
    splitTransaction,
    excludeExpense,
    moveExpenseToFixed,
    deactivateTrackingCategory,
    excludeIncome,
};
//# sourceMappingURL=optimus.js.map